import React from 'react';
import { StyleSheet, Text, View, Linking} from 'react-native';
import {useSelector} from 'react-redux';

export default () => {
    const app = useSelector((state) => state.app);
    return (
        <View style={styles.container}>
            <View style={styles.textRow}>
                <Text style={styles.text2} onPress={() => { Linking.openURL(app.chanelURL) }}>Голуби - Ленинградская</Text>
            </View>
            <View style={styles.email}>
                <Text style={styles.text1}>Обратная связь:  </Text>
                <Text style={styles.text2} onPress={() => { Linking.openURL('mailto:' + app.email) }}>{app.email}</Text>
            </View>
            <Text style={styles.text3}>{app.updated && ` (обновлено ${app.updatedDate.format('LL')})`}</Text>
        </View>
    );
  }
  
  const styles = StyleSheet.create({
    email: {
        display: 'none'
    }, 
    container: {
      padding: 7,
      display: 'flex',
      backgroundColor: '#140b26',
      alignItems: 'center',
      justifyContent: 'flex-start',
      position: 'absolute',
      bottom: 0,
      width: '100%'
    },
    textRow: {
        display: 'flex',
        flexDirection: 'row'
    },
    text1: {
        color: "#aaa",
        fontSize: 14
    },
    text2: {
        color: "#555599",
        textDecorationStyle: 'solid',
        textDecorationColor: '#555599',
        textDecorationLine: 'underline',
        fontSize: 14
    },
    text3: {
        color: "#555577",
        fontSize: 12,
        margin: 3
    },
  });
  